import { useCallback } from "react";
import { useOpenProgressModal } from "../../../../../lib/hooks/useOpenProgressModal";
import ReportService from "../../../../../services/reportGeneration";
import { useDownloadText } from "../../../../Customer/components/Tabs/Profile/Accounts/hooks/useDownloadText";

export const useExport = () => {
  const { isLoading, setIsLoading, download } =
    useDownloadText("1098 Bobby.txt");

  const { openModal } = useOpenProgressModal(
    "Generating Bobby's Tax 1098 Report",
    "Generating Bobby's Tax 1098 Report failed",
    (id?: string) => download(id),
    {},
  );

  const onExport = useCallback(async () => {
    try {
      setIsLoading(true);

      const id: string = await ReportService.exportBulk1098();

      openModal(id);
    } catch {
      setIsLoading(false);
    }
  }, [openModal, setIsLoading]);

  return { isLoading, onExport };
};
